import React from "react";
import "./HomeArchetype.css";
import gd from "../../images/gift-green.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { END_URL, IMG_URL } from "../../config";

function HomeArchetype({PeekWork}) {

  return (
    <div className="homearche-cont">

      <div className="container">

        <div className="row">

          <div className="homearche-title">

            <div className="how-peek-title" dangerouslySetInnerHTML={{__html:PeekWork?.how_peek_work_title}} />

            <div className="homearche-icons">

              {PeekWork?.how_peek_box_1 && (
                <div>
                  <span>
                    <img src={`${IMG_URL}/d0/${PeekWork?.how_peek_box_icon_1}`} alt="" />
                  </span>

                  {PeekWork?.how_peek_box_1}

                </div>
              )}

              {PeekWork?.how_peek_box_2 && (
                <div>
                  <span>
                    <img src={`${IMG_URL}/d0/${PeekWork?.how_peek_box_icon_2}`} alt="" />
                  </span>

                  {PeekWork?.how_peek_box_2}

                </div>
              )}

              {PeekWork?.how_peek_box_3 && (
                <div>
                  <span>
                    <img src={`${IMG_URL}/d0/${PeekWork?.how_peek_box_icon_3}`} alt="" />
                  </span>

                  {PeekWork?.how_peek_box_3}

                </div>
              )}


            </div>
          </div>
        </div>

        <div className="row homearche-cards-row ">

          {PeekWork?.how_peek_box_content_1 && (

            <div className="col-md-4">

                <div
                  className="homearche-cards"
                  style={{ "--home-ar-bg": "#f0e8f8", "--home-ar-text": "#7f3eda" }}
                >
                  <span>1</span>

                  <div dangerouslySetInnerHTML={{__html:PeekWork?.how_peek_box_content_1}} />

                </div>
            </div>
          )}

          {PeekWork?.how_peek_box_content_2 && (

            <div className="col-md-4">
              <div
                className="homearche-cards"
                style={{ "--home-ar-bg": "#e9eff9", "--home-ar-text": "#4e92a5" }}
              >
                <span>2</span>
                
                  <div dangerouslySetInnerHTML={{__html:PeekWork?.how_peek_box_content_2}} />

              </div>
            </div>
          )}

          {PeekWork?.how_peek_box_content_3 && (

            <div className="col-md-4">
              <div
                className="homearche-cards"
                style={{ "--home-ar-bg": "#f0e8f8", "--home-ar-text": "#7f3eda" }}
              >
                <span>3</span>
              
                  <div dangerouslySetInnerHTML={{__html:PeekWork?.how_peek_box_content_3}} />
              </div>
            </div>
          )}

          <div className="homearche-btn-div">

              {PeekWork?.how_peek_start_button_link && PeekWork?.how_peek_start_button_label && (

                <a href={`${PeekWork?.how_peek_start_button_link}`} class="new-commom-btn start-homearche">

                  <span>{PeekWork?.how_peek_start_button_label}</span>

                  <span class="righ-arr">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>
                
              )}

              {PeekWork?.how_peek_explore_button_label && PeekWork?.how_peek_explore_button_link && (

                <a href={`${PeekWork?.how_peek_explore_button_link}`} class="new-commom-btn homearche-explore">

                  <span>{PeekWork?.how_peek_explore_button_label}</span>

                  <span class="righ-arr">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>

              )}

          </div>

        </div>
      </div>
    </div>
  );
}

export default HomeArchetype;
